enum ActionType {
    RECEIVE_AUTH_TOKEN = '[CORE/AUTH] SET TOKEN',
    CLEAR_AUTH_TOKEN = '[CORE/AUTH] CLEAR_AUTH_TOKEN',
}

export default ActionType
